export default __webpack_public_path__ + "static/m-process-06-9c5ed852ac133e4d8b35bfe92db4fea9.svg";